import {
  EventType,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { redirectUrl } from '@/config/config.js';


const tenantId = '7fb979e0-8722-4a01-8803-53786173f28d';
const clientId = '91073084-ee2e-446e-a85d-95d69db36770';

const msalInstance = createMsalInstance()

export function createMsalInstance() {

  const msalInstance = new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: redirectUrl,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  });
  return msalInstance
}

const AuthenticationContext = {
  user: null,
  initialized: false,
  async initialize() {
    if (this.initialized) {
      return;
    }
    await msalInstance.initialize();
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    }
    const account = this.getActiveAccount();
    if (account) {
      this.setUser(account);
    }
    this.initialized = true;
  },
  setUser(account) {
    this.user = {
      account,
      profile: account?.idTokenClaims || {},
    };
  },
  getActiveAccount() {
    
    const active = msalInstance.getActiveAccount();
    if (active) return active;

    const all = msalInstance.getAllAccounts();
    return all.length ? all[0] : null;
  },
  async getAccessToken(scopes, opts) {
    await this.initialize()
    const account = this.getActiveAccount();
    if (!account) {
      await this.login();
      return null;
    }

    const request = { account, scopes, forceRefresh: !!opts?.forceRefresh };
    try {
      const result = await msalInstance.acquireTokenSilent(request);
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        await msalInstance.acquireTokenRedirect({ scopes });
        return null;
      }
      throw error;
    }
  },
  login() {
    return msalInstance.loginRedirect({
      scopes: ["openid", "profile", "email"],
    });
  },
  logout() {
    return msalInstance.logoutRedirect();
  },
  isAuthenticated() {
    return Boolean(this.getActiveAccount());
  },
  checkRoles(roles) {
    if(!this.isAuthenticated()){
      return false;
    }
    if (!Array.isArray(roles) || roles.length === 0) {
      return true;
    }
    const userRoles = this.getActiveAccount()?.idTokenClaims?.roles || [];
    let out = roles.some((role) => userRoles.includes(role));
    return out 
  },
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
    AuthenticationContext.setUser(event.payload.account);
  }
});

export { AuthenticationContext, msalInstance };
